<template>
<div>
    <el-dialog
        append-to-body
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="550px"
        title="新增用户组"
        :visible.sync="dialogVisible"
        custom-class="m-dialog"
        :lock-scroll="false"
        @close="CloseDialog"
    >
        <el-form
            ref="groupForm"
            :rules="rules"
            :model="groupForm"
            size="medium"
            label-width="120px"
        >
            <el-form-item label="名称" prop="Name">
                <el-input
                    v-model="groupForm.Name"
                    class="dialog-text"
                ></el-input>
            </el-form-item>

            <el-form-item label="父级用户组">
                <el-cascader
                    v-model="groupForm.ParentId"
                    :options="data"
                    :props="{
                                    checkStrictly: true
                                }"
                    clearable
                    class="dialog-text"
                    placeholder="请输入关键字检索..."
                ></el-cascader>
            </el-form-item>

            <el-form-item label="备注">
                <el-input
                    v-model="groupForm.DescInfo"
                    class="dialog-text"
                ></el-input>
            </el-form-item>

            <el-form-item label="排序">
                <el-input
                    v-model.number="groupForm.RankNum"
                    class="dialog-text"
                ></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="CloseDialog" size="small"
            >取 消
            </el-button
            >
            <el-button
                type="primary"
                @click="Save('groupForm')"
                size="small"
            >确 定
            </el-button
            >
        </div>
    </el-dialog>
    <el-dialog
        append-to-body
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="760px"
        title="新增用户"
        :visible.sync="userVisible"
        custom-class="m-dialog"
        :lock-scroll="false"
        @close="closeDialog"
    >
        <el-form ref="ruleForm" :rules="rulesForm" size="medium" :model="userForm" label-width="0.5rem">
            <div class="fromflexbox">
                <el-form-item prop="UserName" label="用户名">
                    <el-input
                        v-model="userForm.UserName"
                        class="dialog-text"
                    ></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="pwd">
                    <el-input
                        type="password"
                        show-password
                        v-model="userForm.pwd"
                        class="dialog-text"
                    ></el-input>
                </el-form-item>
            </div>
            <div class="fromflexbox">
                <el-form-item prop="RealName" label="真实姓名">
                    <el-input
                        v-model="userForm.RealName"
                        class="dialog-text"
                    ></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input
                        v-model="userForm.Telephone"
                        class="dialog-text"
                    ></el-input>
                </el-form-item>
            </div>
            <div class="fromflexbox">
                <el-form-item label="地址">
                    <el-input
                        v-model="userForm.Address"
                        class="dialog-text"
                    ></el-input>
                </el-form-item>
                <el-form-item label="邮箱">
                    <el-input
                        v-model="userForm.Email"
                        class="dialog-text"
                    ></el-input>
                </el-form-item>
            </div>

            <div class="fromflexbox">
                <el-form-item label="身份证号">
                    <el-input
                        v-model="userForm.CardId"
                        class="dialog-text"
                    ></el-input>
                </el-form-item>
                <el-form-item label="学号">
                    <el-input
                        v-model="userForm.NumberNo"
                        class="dialog-text"
                    ></el-input>
                </el-form-item>
            </div>
            <div class="fromflexbox">
                <el-form-item label="所属用户组">
                    <el-cascader
                        v-model="userForm.OrganLevelId"
                        :options="data"
                        style="width: 130px; margin-right: 6px"
                        :props="{ checkStrictly: true, emitPath: false }"
                        class="dialog-text"/>
                    <el-button type="primary" size="medium" @click="dialogVisible = true">新增用户组</el-button>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select
                        v-model.number="userForm.Flags"
                        class="dialog-text"
                    >
                        <el-option
                            v-for="item in StateInfoData"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </div>

            <el-form-item label="备注">
                <el-input
                    v-model="userForm.DescInfo"
                    class="dialog-text"
                ></el-input>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="closeDialog">取 消</el-button>
            <el-button size="medium" type="primary" @click="Saveuser('ruleForm')">确 定
            </el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import { AddOrganUser, GetOrganLevelInfo } from "@/api/organ";
import { removeEmptyChildren } from "@/utils";
import { cloneDeep } from "lodash";
import { SaveOrganGroup } from "@/api/category";
import { sm2Encrypt } from "@/utils/sm2";

export default {
    name: "addUser",
    data () {
        return {
            dialogVisible: false,
            // 用户组表单
            groupForm: {
                ID: 0,
                ParentId: [],
                Name: "",
                RankNum: null,
                DescInfo: ""
            },
            userVisible: false,
            // 用户状态
            StateInfoData: [
                {
                    value: 0,
                    name: "正常"
                },
                {
                    value: 1,
                    name: "停用"
                }
            ],
            rules: {
                Name: [
                    {
                        required: true,
                        message: "请填写用户组名称",
                        trigger: "blur"
                    }
                ]
            },
            // 表单验证规则
            rulesForm: {
                UserName: [
                    {
                        required: true,
                        message: "请输入用户名",
                        trigger: "blur"
                    }
                ],
                pwd: [
                    {
                        required: true,
                        message: "请输入密码",
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        max: 20,
                        message: "长度在 6 到 20 个字符",
                        trigger: "blur"
                    }

                ],
                RealName: [
                    {
                        required: true,
                        message: "请输入真实姓名",
                        trigger: "blur"
                    },
                    {
                        min: 2,
                        max: 20,
                        message: "长度在 2 到 20 个字符",
                        trigger: "blur"
                    }
                ]
            },
            data: [],
            // 表单
            userForm: {
                ID: "",
                UserName: "",
                UserPass: "",
                RealName: "",
                Telephone: "",
                Email: "",
                Address: "",
                CardId: "",
                NumberNo: "",
                Flags: 0,
                GroupUserId: "",
                OrganLevelId: 0,
                Balance: 0,
                DescInfo: "",
                UserRoleType: 0,
                UserType: 2,
                ImportFlags: -1
            },
        }
    },
    methods: {
        // 关闭弹框
        CloseDialog() {
            this.dialogVisible = false;
            this.groupForm = {
                ID: 0,
                ParentId: null,
                Name: "",
                RankNum: null,
                DescInfo: ""
            };
        },
        // 关闭弹框
        closeDialog() {
            this.userVisible = false;

            this.userForm = {
                ID: "",
                UserName: "",
                UserPass: "",
                RealName: "",
                Telephone: "",
                Email: "",
                Address: "",
                CardId: "",
                NumberNo: "",
                Flags: 0,
                GroupUserId: "",
                OrganLevelId: 0,
                Balance: 0,
                DescInfo: "",
                UserRoleType: 0,
                UserType: 2,
                ImportFlags: -1
            };
        },
        // 获取机构用户组信息
        async GetOrganGroupInfo() {
            try {
                const { data } = await GetOrganLevelInfo();
                if (Array.isArray(data.data) && data.data.length > 0) {
                    this.data = data.data;
                    removeEmptyChildren(this.data, "children");
                }
                // this.data.splice(0, 0, { KnowledgePointName: "无", id: "0" })
            } catch (err) {
                this.$message.error("获取失败");
            }
        },
        // 保存模块
        async Save(formName) {
            var result = false;
            this.$refs[formName].validate((valid) => {
                result = valid;
            });

            if (result) {
                try {
                    let form = cloneDeep(this.groupForm);
                    if (Array.isArray(form.ParentId)) {
                        form.ParentId = form.ParentId.pop();
                    }
                    const { data } = await SaveOrganGroup(form);

                    if (data.code === 100) {
                        this.$message({
                            message: "保存成功！",
                            type: "success"
                        });
                        this.GetOrganGroupInfo();
                        this.CloseDialog();
                    } else {
                        this.$message({
                            message: data.msg,
                            type: "error"
                        });
                    }
                } catch (err) {
                    console.error(err);
                    this.$message({
                        message: "服务器开小差了",
                        type: "error"
                    });
                }
            }
        },
        // 保存
        async Saveuser(ruleForm) {
            // this.$refs.ruleForm.validate()
            this.$refs[ruleForm].validate((valid) => {
                if (valid) {
                    this.userForm.UserPass = sm2Encrypt(this.userForm.pwd);
                    this.AddUser();
                    this.$emit("importSuccess")
                } else {
                    // console.log("error submit!!");
                    return false;
                }
            });
        },
        // 新增用户
        async AddUser() {
            try {
                const { data } = await AddOrganUser(this.userForm);
                if (data.code === 100) {
                    this.$message({
                        message: data.msg,
                        type: "success"
                    });
                    this.userVisible = false;
                } else {
                    this.$message({
                        message: data.msg,
                        type: "error"
                    });
                }
            } catch (err) {
                this.$message({
                    message: "服务器开小差了",
                    type: "error"
                });
            }
        },
        open () {
            this.userVisible = true
            this.GetOrganGroupInfo()
        },
        close () {
            this.userVisible = false
        }
    }
}
</script>

<style scoped lang="less">
.fromflexbox {
    display: flex;
}
.dialog-text {
    width: 300px;
}

::v-deep .el-dialog__body {
.dialog-text {
    width: 250px;
}
}
</style>
